import React from "react";
import Helmet from "react-helmet"


export default function SEO(props) {
  return (
    <Helmet>
      <title>{props.title ? props.title : "Engineering for Humanity | Olin College of Engineering"}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="author" content="Olin College of Engineering" />
      <meta name="description" content={props.description ? props.description : "This site is a Curriculum Resource and point of connection for educators interested in adapting material from the “Engineering for Humanity” course offered at Olin College of Engineering."} />
      <meta name="keywords" content={""} />
    </Helmet>
  )
}
